module.exports = __webpack_public_path__ + "img/20220822143550235023.0fa03b09.jpg";